import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Redirect } from 'react-router-dom';
import { GridList, GridTile } from 'material-ui/GridList';
import { connect } from "react-redux";
import { getUserProjects } from '../../redux/projects/actions';
import * as selectors from '../../redux/projects/selectors';
import * as authSelectors from '../../redux/auth/selectors';
import defaultProjectImage from '../../assets/default-project.jpg';
import ActivityIndicator from 'react-activity-indicator';
import _ from 'lodash';
import moment from 'moment';
import '../../styles/GridList.css';
import './Projects.css';

const mapStateToProps = (state) => ({
  userId: authSelectors.getUserId(state),
  projectsList: selectors.projectsList(state),
  projectFetched: selectors.projectIsFetched(state),
  projectIsFetching: selectors.projectIsFetching(state),
  selectedProjectId: selectors.selectedProjectId(state)
});

const mapDispatchToProps = {
  getUserProjects
};

class ProjectsScreen extends Component {

  state = {};

  componentDidMount() {
    if (!this.componentHasData()) {
      this.componentUpdateData();
    }
  }

  componentWillReceiveProps(nextProps) {
    const { projectsList } = nextProps;

    if (nextProps === this.props) {
      return;
    }

    if (!this.componentHasData()) {
      this.componentUpdateData(nextProps);
    }
  }

  componentHasData() {
    return this.props.projectFetched && this.props.userId;
  }

  componentUpdateData(props = this.props) {
    const { projectsList } = props;
    this.setState({isUpdated: true})

    if (Object.keys(projectsList).length === 0 && props.userId) {
      this.props.getUserProjects(props.userId)
    }
  }

  renderProjects = () => {
    const { projectsList, selectedProjectId } = this.props;
    const projectId = Object.keys(projectsList).filter((project) => project === selectedProjectId ? project : projectsList[0]);

    if (projectId.length) {
        const project = projectsList[projectId[0]];
        const previewImageStyles = {
          backgroundImage: `url(${typeof project.images !== 'undefined' ? project.images.main : defaultProjectImage})`
        };


        return (
          <Redirect to={`/dashboard/project/${projectId[0]}`} key={`project-${project.id}`}>
            <GridTile
              // title={project.title}
            >
              <div className="placeholder">
                <div className="image" style={previewImageStyles} />
              </div>
              <div className="title expressive">
                {project.title}
              </div>
            </GridTile>
          </Redirect>
        );
      // })
    }
  };

  render() {
    const { projectsList, projectFetched, projectIsFetching } = this.props;

    return (
      <div className="dashboard-page-wrap">
        <Grid className="dashboard-page dashboard-page-small">
          {projectFetched &&
          <Row top="xs" className="projects-list grid-list-container">
            <Col xs={12}>
              <GridList className="grid-list with-title-below highlightable" padding={16}>
                {this.renderProjects()}
              </GridList>
            </Col>
          </Row>
          }
          {projectIsFetching &&
          <Row center="xs" middle="xs" className="activity-wrapper">
            <Col xs={12}>
              <ActivityIndicator
                number={5}
                diameter={40}
                duration={100}
                activeColor="#5BA22F"
                borderColor="white"
                borderWidth={5}
                borderRadius="50%"
              />
            </Col>
          </Row>
          }
          {projectFetched &&  Object.keys(projectsList).length === 0 &&
          <Row center="xs" middle="xs" >
            <Col xs={12}>
              No projects found
            </Col>
          </Row>
          }
        </Grid>
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProjectsScreen);
